import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingNavItemComponent } from '../landing-nav-item/landing-nav-item.component';
import { boostThemeEnum } from '@app/services/page.service';
import { LandingNavItem } from '../landing-nav-item/landing-nav-item.model';
import { ScoreLocalService } from '@app/pages/score/score.service';
import { PlanService } from '@app/pages/plan-old/plan.service';
import { HomeService } from '@app/pages/home/home.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-landing-plan',
  standalone: true,
  imports: [CommonModule, LandingNavItemComponent],
  templateUrl: './landing-plan.component.html',
  styleUrls: ['./landing-plan.component.scss']
})
export class LandingPlanComponent implements OnInit, OnDestroy {

  planNavItem: LandingNavItem = { 
    theme: boostThemeEnum.glacier,
    contentTheme: "starlight",
    title: "Make a Plan",
    content:
      "Plan your day's activities, making sure you play lots of safety cards to help you reach the end of the day with a strong Safety Buffer.",
    action: "PLAN NOW",
    routerLink: "/plan-home",
  };

  private scoreCacheSubscription?: Subscription;
  private plansLoadedSubscription?: Subscription;

  userHasPlan: boolean = false;

  constructor(
    private scoreLocalService: ScoreLocalService,
    private planService: PlanService,
    private homeService: HomeService
  ) {}

  ngOnInit(): void {
    // Subscribe to score cache updates
    this.scoreCacheSubscription = this.scoreLocalService.scoreCacheUpdated.subscribe(() => {
      this.updatePlanNavItem();
    });

    // Subscribe to plans loaded updates
    this.plansLoadedSubscription = this.homeService.onPlansLoaded.subscribe(() => {
      this.updatePlanNavItem();
    });

    // Initial update
    this.updatePlanNavItem();
  }

  ngOnDestroy(): void {
    if (this.scoreCacheSubscription) {
      this.scoreCacheSubscription.unsubscribe();
    }
    if (this.plansLoadedSubscription) {
      this.plansLoadedSubscription.unsubscribe();
    }
  }

  private updatePlanNavItem(): void {
    const scoresCountToday = this.scoreLocalService.getCachedScoresCountToday();
    const hasScoreToday = scoresCountToday !== null && scoresCountToday > 0;
    const planExistsToday = this.planService.checkIfPlanExistsToday();
    const todayPlanId = this.planService.getTodayPlanId();
    
    // If a plan exists for today, show the plan view option
    if (planExistsToday && todayPlanId) {
      // Scenario 3: User has scored and made a plan
      // Scenario 4: User's score time has elapsed but user has a plan
      this.planNavItem = {
        theme: boostThemeEnum.glacier,
        title: "Today's Plan",
        content: "You can edit today's plan at any time - it's ok to drop an activity card if the day is feeling too full, or add in extra safety cards if you need a safety boost.",
        routerLink: `/plan/do/${todayPlanId}`,
        action: "VIEW YOUR PLAN",
        contentTheme: "wild-hare",
      }
      this.userHasPlan = true;
    }
    // Scenario 2: User has scored and not made a plan
    else if (hasScoreToday && !planExistsToday) {
      this.planNavItem = {
        theme: boostThemeEnum.glacier,
        contentTheme: "starlight",
        title: "It's time to Plan!",
        content: "Now that you've completed a scoring session and know what today's safety buffer looks like, you can plan out your day.",
        routerLink: "/plan-home",
        action: "PLAN NOW",
      }
    }
    // Scenario 1: User has not scored or made a plan
    else {
      this.planNavItem = {
        theme: boostThemeEnum.glacier,
        contentTheme: "starlight",
        title: "Make a Plan",
        content: "Plan your day's activities, making sure you play lots of safety cards to help you reach the end of the day with a strong Safety Buffer.",
        routerLink: "/plan-home",
        action: "PLAN NOW",
      }
    }
  }

}
